'use strict';
module.exports = function (val) {
	if (val === null || val === undefined) {
		return [];
	}

	return Array.isArray(val) ? val : [val];
};



//////////////////
// WEBPACK FOOTER
// ./~/arrify/index.js
// module id = 1981
// module chunks = 0